import { reactive } from "vue";

const store = reactive({
  globalView: false
})
export default store;



// WEBPACK FOOTER //
// ./src/store/dashboards.js